import { UrlConstants } from "../url.constants";
export class ApiLookupConstants {
    static URL = UrlConstants.API_V2 + "Lookup";
    static FUNCTION_DELETE_MULTIPLE_LOOKUPS = "DeleteMultipleLookups";
    static FUNCTION_GET_LOOKUP_ATTACHMENT = "GetLookupAttachment";
    static FUNCTION_UPLOAD_LOOKUP_ATTACHMENT = "UploadLookupAttachment";
    static FUNCTION_DELETE_ALL_LOOKUPS = "DeleteAllLookups";
    static FUNCTION_GET_LOOKUPS_FOR_AFLA_PORTAL = "GetLookupsForAFLAPortal";
}
